// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0

/**
 * This package provides the default theme for Ory Elements React.
 *
 * @packageDocumentation
 * @module default-theme
 */

import "./global.css"
export * from "./components"
export * from "./flows"
